import { Container } from "inversify";
import { DependencyType } from "./DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { buildApolloClient } from "../modules/apollo/apollo.factory";
import { StorageService } from "../modules/storage/storage.service";
import { AuthenticationService } from "../modules/authentication/authentication.service";
import { UserService } from "../modules/user/user.service";
import { BatchService } from "../modules/batch/batch.service";
import { SerialRangeService } from "@modules/serial-range/serial-range.service";
import { ProductTypeService } from "@modules/product-type/ProductType.service";
import { SoilTypeService } from "@modules/soil-type/soil-type.service";
import { CropService } from "@modules/crop/crop.service";
import { CropTypeService } from "@modules/crop-type/crop-type.service";
import { CultivationService } from "@modules/cultivation/cultivation.service";
import { CoverCropService } from "@modules/cover-crop/cover-crop.service";
import { SoilSampleService } from "@modules/soil-sample/soil-sample.service";
import { LaboratoryService } from "@modules/laboratory/laboratory.service";
import { LabIndicatorDefinitionService } from "@modules/lab-indicator-definition/lab-indicator-definition.service";
import { LabResultService } from "@modules/lab-result/lab-result-service";

export const dependenciesContainer = new Container();

export const initDependencies = async (): Promise<void> => {
  dependenciesContainer
    .bind<ApolloClient<NormalizedCacheObject>>(DependencyType.ApolloClient)
    .toConstantValue(buildApolloClient());

  dependenciesContainer
    .bind<StorageService>(DependencyType.StorageService)
    .to(StorageService)
    .inSingletonScope();

  dependenciesContainer
    .bind<AuthenticationService>(DependencyType.AuthenticationService)
    .to(AuthenticationService)
    .inSingletonScope();

  dependenciesContainer
    .bind<UserService>(DependencyType.UserService)
    .to(UserService)
    .inSingletonScope();

  dependenciesContainer
    .bind<BatchService>(DependencyType.BatchService)
    .to(BatchService)
    .inSingletonScope();

  dependenciesContainer
    .bind<SerialRangeService>(DependencyType.SerialRangeService)
    .to(SerialRangeService)
    .inSingletonScope();

  dependenciesContainer
    .bind<ProductTypeService>(DependencyType.ProductTypeService)
    .to(ProductTypeService)
    .inSingletonScope();

  dependenciesContainer
    .bind<SoilTypeService>(DependencyType.SoilTypeService)
    .to(SoilTypeService)
    .inSingletonScope();

  dependenciesContainer
    .bind<CropService>(DependencyType.CropService)
    .to(CropService)
    .inSingletonScope();

  dependenciesContainer
    .bind<CropTypeService>(DependencyType.CropTypeService)
    .to(CropTypeService)
    .inSingletonScope();

  dependenciesContainer
    .bind<CultivationService>(DependencyType.CultivationService)
    .to(CultivationService)
    .inSingletonScope();

  dependenciesContainer
    .bind<CoverCropService>(DependencyType.CoverCropService)
    .to(CoverCropService)
    .inSingletonScope();

  dependenciesContainer
    .bind<SoilSampleService>(DependencyType.SoilSampleService)
    .to(SoilSampleService)
    .inSingletonScope();

  dependenciesContainer
    .bind<LaboratoryService>(DependencyType.LaboratoryService)
    .to(LaboratoryService)
    .inSingletonScope();

  dependenciesContainer
    .bind<LabIndicatorDefinitionService>(
      DependencyType.LabIndicatorDefinitionService
    )
    .to(LabIndicatorDefinitionService)
    .inSingletonScope();

  dependenciesContainer
    .bind<LabResultService>(DependencyType.LabResultService)
    .to(LabResultService)
    .inSingletonScope();
};
